import { StateService } from '@supoui/core/state-services/state.service';
import { SupoInvoice } from '@supoui/shared/model/supo-invoice';
import { Observable } from 'rxjs';

export class SupoInvoiceStateService extends StateService<SupoInvoice[]> {
  public sendSupoInvoices(obj: SupoInvoice[]) {
    this.sendModel(obj);
  }

  public getSupoInvoices(): Observable<SupoInvoice[]> {
    return this.getModel();
  }
}
